import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent, ref, computed, watch } from "vue";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { useI18n } from "vue-i18n";
import { closeCashfloat, getCashBookingsAmount, getCashBookingsAmountWithoutRefund, getCashChange, getCashRefund, hasMultiCurrenciesEnabled } from "@/utils/vue-helpers/cash-float";
import CashFloatModule from "@/store/modules/cash-float";
import POSConfigModule from "@/store/modules/pos-config";
import UserModule from "@/store/modules/user";
import dayjs from "dayjs";
import { Currencies, allDetailedCurrencies } from "@/constants/currency";
import DeviceModule from "@/store/modules/device";
import { insertCashTransfer } from "@/utils/helpers/db";
import { LogLevel, LogService } from "@/services/logging";
import BookingModule from "@/store/modules/booking";
import { formatDateTime } from "@/utils/helpers/dates";
import { getGroupInfo } from "@/utils/vue-helpers/group";
import { printClosingReceipt } from "@/printing/handlers/receipts";
import { resetGrowingCollecitonsFromUI, setDBReset } from "@/utils/vue-helpers/db";
import AuthModule from "@/store/modules/auth";
import AppModule from "@/store/modules/app";
import { redirectToLoginPage } from "@/utils/helpers/router.helper";
import { clearShallLogout, hideDialog, shallLogout } from "@/utils/vue-helpers/modal";
import check from "@/assets/images/svg/white-check.svg";
import cardHolder from "@/assets/images/svg/card-holder.svg";
import { Edit as EditIcon } from "@element-plus/icons-vue";
import { cloneDeep, debounce } from "lodash";
import randomstring from "randomstring";
import LogsModule from "@/store/modules/logs";
import NotificationService from "@/services/notification.service";
import { dexieDB } from "@/services/dexie-database";
import { closeCashPoint } from "@/utils/helpers/fiskaly";
var CashfloatType;

(function (CashfloatType) {
  CashfloatType["Detailed"] = "Detailed";
  CashfloatType["General"] = "General";
})(CashfloatType || (CashfloatType = {}));

export default defineComponent({
  name: ModalComponents.NewCashfloatClose,
  setup: function setup() {
    var iconStyle = "width: 20px; height: 20px;";
    var iconContent = check;
    var iconAlt = "check";
    var drawerIconStyle = "width: 40px; height: 40px;";
    var drawerIconContent = cardHolder;
    var drawerIconAlt = "cardHolder";

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var isLoading = ref(false);
    var showCoinsAndBillsDialog = ref(false);
    var coinsAndBillsDialogCurrency = ref(null);
    var willMoneyStayInDrawer = ref(false);
    var showErrorMsg = ref(false); // Final cashfloat entered by the user, we initiate it same as calculated final cashfloat

    var expectedCashfloats = ref({});
    var finalManualCashfloats = ref({});
    var cashDetailsArea = ref(null);
    var totalCashSalesWithoutRefund = ref({});
    var totalCashRefund = ref(0);
    var totalChangeGivenBack = ref(0);
    var cashNoteDialogVisibility = ref(false);
    var cashNoteCurrency = ref();
    var cashNotes = ref({});
    var groupCurrencies = computed(function () {
      return POSConfigModule.groupCurrencies;
    });
    var transfersAmount = computed(function () {
      return CashFloatModule.getTransfersAmount;
    });
    var groupCurrency = computed(function () {
      var currency = groupCurrencies.value.find(function (c) {
        return c.isDefault === 1;
      }) || groupCurrencies.value[0];
      return currency.label;
    });
    var getSumOfCashOut = computed(function () {
      return CashFloatModule.getSumOfCashOut / 100 + totalCashRefund.value + totalChangeGivenBack.value;
    });
    var getSumOfCashIn = computed(function () {
      return CashFloatModule.getSumOfCashIn / 100;
    });
    watch([getSumOfCashIn, getSumOfCashOut], function () {
      // if user transfers cash while closing sales, expected and final amounts should be updated accordingly
      var currency = groupCurrency.value;
      var startAmount = cashFloatStartAmounts.value[currency] || 0;
      var totalCashSales = totalCashSalesByCurrency.value[currency] || 0;
      expectedCashfloats.value[currency] = startAmount + (totalCashSales + getSumOfCashIn.value - getSumOfCashOut.value);
      finalManualCashfloats.value[currency] = expectedCashfloats.value[currency];
    });
    var totalCashSalesByCurrency = computed(function () {
      var cashSales = {};

      for (var i in currencies.value) {
        var currency = currencies.value[i];
        cashSales[currency.label] = parseFloat((totalCashSalesWithoutRefund.value[currency.label] || 0).toFixed(2));
      }

      return cashSales;
    });
    var currencies = computed(function () {
      var currencies = [];

      if (!hasMultiCurrenciesEnabled.value) {
        var currencyInfo = groupCurrencies.value.find(function (c) {
          return c.label === groupCurrency.value;
        });
        currencies.push(currencyInfo);
      } else {
        var _CashFloatModule$cash;

        var startAmounts = (_CashFloatModule$cash = CashFloatModule.cashFloat) === null || _CashFloatModule$cash === void 0 ? void 0 : _CashFloatModule$cash.startAmounts;

        var _loop = function _loop(currency) {
          var currencyInfo = groupCurrencies.value.find(function (c) {
            return c.label === currency;
          });

          if (currencyInfo) {
            currencies.push(currencyInfo);
          }
        };

        for (var currency in startAmounts) {
          _loop(currency);
        }
      }

      return currencies;
    }); // We only show in UI the currencies used by the organizer

    var initialDetailedCurrencies = allDetailedCurrencies.filter(function (c) {
      return currencies.value.some(function (c1) {
        return c1.label === c.label;
      });
    });
    var detailedCurrencies = ref(cloneDeep(initialDetailedCurrencies)); // locations shown to the user to choose from to becash out of this location

    var locationsList = computed(function () {
      return DeviceModule.locations.filter(function (l) {
        var _DeviceModule$deviceI;

        return l.id !== Number((_DeviceModule$deviceI = DeviceModule.deviceInfo) === null || _DeviceModule$deviceI === void 0 ? void 0 : _DeviceModule$deviceI.locationId);
      });
    }); // this the selected location

    var locationId = ref(
    /*locationsList.value && locationsList.value.length
      ? locationsList.value[0].id
      : */
    null);
    var hasLocation = computed(function () {
      // If there is no hardware location (machine not linked to a location or user using a browser) we don't show device settings
      if (DeviceModule.hardwareLocation) {
        return true;
      } else {
        return false;
      }
    }); // this is an object whereas the keys are the values of label field in currencies variable

    var totalByCurrency = ref({});

    for (var i = 0; i < currencies.value.length; i++) {
      totalByCurrency.value[currencies.value[i].label] = "";
    } // TODO HAMZA MULTIPLE CURRENCIES SUPPORT: no need for this when we start supporting multiple currencies


    var cashfloatOpeningAmount = computed(function () {
      // We only take the first currency amount since backend only support one currency now
      var keys = Object.keys(totalByCurrency.value);
      return totalByCurrency.value[keys[0]];
    });
    var differenceValues = computed(function () {
      var values = {};

      for (var _i in currencies.value) {
        var currency = currencies.value[_i].label;
        values[currency] = (finalManualCashfloats.value[currency] || 0) - (cashFloatStartAmounts.value[currency] || 0);
      }

      return values;
    });
    var groupCurrencySymbol = computed(function () {
      switch (groupCurrency.value) {
        case Currencies.EUR:
          return "€";

        case Currencies.CHF:
          return "CHF";

        case Currencies.USD:
          return "$";

        case Currencies.GBP:
          return "£";

        default:
          return "CHF";
      }
    });
    var userFirstName = computed(function () {
      return UserModule.getUser.firstName;
    });
    var cashFloatStartAmounts = computed(function () {
      if (CashFloatModule.getCashFloat) {
        var startAmounts = {};

        for (var currency in CashFloatModule.getCashFloat.startAmounts) {
          startAmounts[currency] = (CashFloatModule.getCashFloat.startAmounts[currency] || 0) / 100;
        }

        return startAmounts;
      }

      return {};
    });
    var getSelectedDetailedCurrency = computed(function () {
      var result = [];

      if (coinsAndBillsDialogCurrency.value) {
        var currency = detailedCurrencies.value.find(function (curr) {
          return curr.label === coinsAndBillsDialogCurrency.value;
        });

        if (currency) {
          result.push(currency);
        }
      }

      return result;
    }); // When user do a cash movement we need to update numbers of closing amount in UI

    watch(transfersAmount, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newTransfersAmount, oldTransfersAmount) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // only main currency for cash transfers
                expectedCashfloats.value[groupCurrency.value] = (cashFloatStartAmounts.value[groupCurrency.value] || 0) + (totalCashSalesByCurrency.value[groupCurrency.value] - getSumOfCashOut.value);
                finalManualCashfloats.value[groupCurrency.value] = expectedCashfloats.value[groupCurrency.value];

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    function currencySymbol(currency) {
      switch (currency) {
        case Currencies.EUR:
          return "€";

        case Currencies.CHF:
          return "CHF";

        case Currencies.USD:
          return "$";

        case Currencies.GBP:
          return "£";

        default:
          return "CHF";
      }
    }

    function sumCashByCurrency(currencyLabel) {
      var currency = detailedCurrencies.value.find(function (c) {
        return c.label === currencyLabel;
      });

      if (currency) {
        var sum = 0;

        for (var _i2 = 0; _i2 < currency.bills.length; _i2++) {
          sum = sum + Number(currency.bills[_i2].name) * Number(currency.bills[_i2].userInput);
        }

        for (var _i3 = 0; _i3 < currency.coins.length; _i3++) {
          sum = sum + Number(currency.coins[_i3].name) * Number(currency.coins[_i3].userInput);
        }

        for (var _i4 = 0; _i4 < currency.cents.length; _i4++) {
          sum = sum + Number(currency.cents[_i4].name) * Number(currency.cents[_i4].userInput) / 100;
        }

        return sum;
      }

      return 0;
    }

    function scrollToTop() {
      var _cashDetailsArea$valu;

      (_cashDetailsArea$valu = cashDetailsArea.value) === null || _cashDetailsArea$valu === void 0 ? void 0 : _cashDetailsArea$valu.scrollTo({
        // top: cashDetailsArea.value?.scrollHeight,
        top: 0,
        behavior: "smooth"
      });
    }

    function scrollTo(position) {
      var _cashDetailsArea$valu2;

      (_cashDetailsArea$valu2 = cashDetailsArea.value) === null || _cashDetailsArea$valu2 === void 0 ? void 0 : _cashDetailsArea$valu2.scrollTo({
        top: position,
        behavior: "smooth"
      });
    }

    function displayCoinsAndBillsDialog(currency) {
      coinsAndBillsDialogCurrency.value = currency;
      showCoinsAndBillsDialog.value = true;
    }

    function resetLocationId() {
      locationId.value = null;
    }

    function componentCloseCashfloat() {
      return _componentCloseCashfloat.apply(this, arguments);
    }
    /**
     * Collects data for closing receipt and print it (no cash transfers considered)
     * Triggered when user logs out
     */


    function _componentCloseCashfloat() {
      _componentCloseCashfloat = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var cashFloat, isCashfloatCashedOut, _i5, currency, difference, groupId, isGain, from, to, _DeviceModule$hardwar, _DeviceModule$hardwar2, _DeviceModule$hardwar3, _DeviceModule$hardwar4, cashTransferOut, _DeviceModule$hardwar5, _DeviceModule$hardwar6, _from, _to, _cashTransferOut, detailedMainCurrency, hasCashClosingSum, unsynchedBookingsUuid, expectedCashfloatsInCents, finalManualCashfloatsInCents, billsAndCoins, closingAmounts, cashfloatInfo, memory, mem, unsynchedDexieLogsCount, retry, unsynchedLogsCount, _retry;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                cashFloat = CashFloatModule.cashFloat;

                if (cashFloat) {
                  _context2.next = 5;
                  break;
                }

                LogService.info("No cashfloat found while closing sales", undefined, LogLevel.Error);
                return _context2.abrupt("return");

              case 5:
                isCashfloatCashedOut = false; // For Electron app we show an error message if there is no locationId selected and the checkbox isn't ticked

                if (!(hasLocation.value && !locationId.value && !willMoneyStayInDrawer.value)) {
                  _context2.next = 9;
                  break;
                }

                showErrorMsg.value = true;
                return _context2.abrupt("return");

              case 9:
                _context2.t0 = regeneratorRuntime.keys(currencies.value);

              case 10:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 20;
                  break;
                }

                _i5 = _context2.t1.value;
                currency = currencies.value[_i5].label;
                difference = Number(finalManualCashfloats.value[currency]) - Number(expectedCashfloats.value[currency]);

                if (!(difference !== 0 && !cashNotes.value[currency])) {
                  _context2.next = 18;
                  break;
                }

                NotificationService.showCustomMessageWithTitle(t("cashfloat.add-note-warning"), t("common.warning"), "warning");
                this.shakeText(currency);
                return _context2.abrupt("return");

              case 18:
                _context2.next = 10;
                break;

              case 20:
                ////
                // Loading
                AppModule.updatedIsLoading(true);
                groupId = POSConfigModule.groupId || UserModule.getUserGroupId; // Before doing a potential CashOut and before Closing the cashfloat we will
                // we will check if there is a difference between expected closing amount and manual closing amount
                // in order to track the difference via a cash transfer

                if (!hasLocation.value) {
                  _context2.next = 40;
                  break;
                }

                if (!(finalManualCashfloats.value[groupCurrency.value] !== expectedCashfloats.value[groupCurrency.value])) {
                  _context2.next = 40;
                  break;
                }

                // so we have a difference that needs to be tracked via cash transfer
                LogService.info("There is cash difference when closing the cashfloat ".concat(cashFloat === null || cashFloat === void 0 ? void 0 : cashFloat.uid, " as attached"), {
                  params: {
                    currency: groupCurrency.value,
                    expectedCashfloat: expectedCashfloats.value[groupCurrency.value],
                    finalManualCashfloat: finalManualCashfloats.value[groupCurrency.value]
                  }
                });
                isGain = false;

                if (finalManualCashfloats.value[groupCurrency.value] > expectedCashfloats.value[groupCurrency.value]) {
                  isGain = true;
                }

                from = null;
                to = null;

                if (isGain) {
                  // cashIn to the device because it is a gain
                  to = DeviceModule.hardwareLocation && (_DeviceModule$hardwar = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar !== void 0 && _DeviceModule$hardwar.locationId ? Number((_DeviceModule$hardwar2 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar2 === void 0 ? void 0 : _DeviceModule$hardwar2.locationId) : null;
                  from = null;
                } else {
                  // cashOut from the device because it is a loss
                  from = DeviceModule.hardwareLocation && (_DeviceModule$hardwar3 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar3 !== void 0 && _DeviceModule$hardwar3.locationId ? Number((_DeviceModule$hardwar4 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar4 === void 0 ? void 0 : _DeviceModule$hardwar4.locationId) : null;
                  to = null;
                }

                cashTransferOut = {
                  _id: dayjs().toISOString(),
                  createdAt: dayjs().toISOString(),
                  amount: Math.abs(Number(expectedCashfloats.value[groupCurrency.value]) - Number(finalManualCashfloats.value[groupCurrency.value])),
                  currency: groupCurrency.value,
                  groupId: Number(groupId),
                  from: from,
                  to: to,
                  note: cashNotes.value[groupCurrency.value] || null,
                  channel: "Smeetz POS",
                  uuid: randomstring.generate(10),
                  isGainLoss: true
                };
                _context2.prev = 31;
                LogService.info("Inserting cashTranser to indexedDB (attached)", {
                  params: cashTransferOut
                });
                _context2.next = 35;
                return insertCashTransfer(cashTransferOut);

              case 35:
                _context2.next = 40;
                break;

              case 37:
                _context2.prev = 37;
                _context2.t2 = _context2["catch"](31);
                LogService.info("Error when hadnling cash transfer ".concat(cashTransferOut.uuid), {
                  params: {
                    error: _context2.t2
                  }
                }, LogLevel.Error);

              case 40:
                if (!(hasLocation.value && !willMoneyStayInDrawer.value)) {
                  _context2.next = 58;
                  break;
                }

                LogService.info("User decided to cashout cashfloat closing amount ".concat(cashFloat.uid));
                _from = DeviceModule.hardwareLocation && (_DeviceModule$hardwar5 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar5 !== void 0 && _DeviceModule$hardwar5.locationId ? Number((_DeviceModule$hardwar6 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar6 === void 0 ? void 0 : _DeviceModule$hardwar6.locationId) : null;
                _to = locationId.value || null;

                if (_to) {
                  _context2.next = 47;
                  break;
                }

                _context2.next = 58;
                break;

              case 47:
                // Add a new CashTransfer of type (OUT)
                _cashTransferOut = {
                  _id: dayjs().toISOString(),
                  createdAt: dayjs().toISOString(),
                  amount: Number(finalManualCashfloats.value[groupCurrency.value]
                  /*form.cashFloatAmount*/
                  ),
                  currency: groupCurrency.value
                  /*Currencies.CHF*/
                  ,
                  groupId: Number(groupId),
                  from: _from,
                  to: _to,
                  note: "",
                  channel: "Smeetz POS",
                  uuid: randomstring.generate(10)
                };
                _context2.prev = 48;
                LogService.info("Inserting cashTranser to indexedDB (attached)", {
                  params: _cashTransferOut
                });
                _context2.next = 52;
                return insertCashTransfer(_cashTransferOut);

              case 52:
                isCashfloatCashedOut = true;
                _context2.next = 58;
                break;

              case 55:
                _context2.prev = 55;
                _context2.t3 = _context2["catch"](48);
                LogService.info("Error when hadnling cash transfer ".concat(_cashTransferOut.uuid), {
                  params: {
                    error: _context2.t3
                  }
                }, LogLevel.Error);

              case 58:
                // const cashFloat = CashFloatModule.cashFloat;
                // if (!cashFloat) {
                //   LogService.info(
                //     "No cashfloat found while closing sales",
                //     undefined,
                //     LogLevel.Error
                //   );
                //   return;
                // }
                detailedMainCurrency = detailedCurrencies.value.find(function (c) {
                  return c.label === groupCurrency.value;
                }); // check if one of the bills and coins inputs was filled

                hasCashClosingSum = function hasCashClosingSum() {
                  return detailedCurrencies.value.find(function (detailedCurrency) {
                    return sumCashByCurrency(detailedCurrency.id);
                  });
                };

                _context2.prev = 60;

                if (Object.keys(BookingModule.bookingsPendingSynchronization).length) {
                  unsynchedBookingsUuid = Object.keys(BookingModule.bookingsPendingSynchronization).map(function (it) {
                    return it;
                  });
                  LogService.info("The following bookings were not synched to backend: ".concat(unsynchedBookingsUuid, " while closing the cashfloat with uuid ").concat(cashFloat.uid), {
                    params: {
                      bookingUuids: unsynchedBookingsUuid
                    }
                  });
                }

                expectedCashfloatsInCents = {};
                finalManualCashfloatsInCents = {};
                detailedCurrencies.value.forEach(function (detailedCurrency) {
                  expectedCashfloatsInCents[detailedCurrency.label] = (expectedCashfloats.value[detailedCurrency.label] || 0) * 100;
                  finalManualCashfloatsInCents[detailedCurrency.label] = (finalManualCashfloats.value[detailedCurrency.label] || 0) * 100;
                });

                if (!hasCashClosingSum()) {
                  _context2.next = 81;
                  break;
                }

                // lets take only details of the first currency
                billsAndCoins = [];

                if (detailedMainCurrency) {
                  billsAndCoins.push({
                    currency: detailedMainCurrency.label,
                    bills: detailedMainCurrency.bills.map(function (b) {
                      return {
                        name: b.name,
                        userInput: b.userInput
                      };
                    }),
                    coins: detailedMainCurrency.coins.map(function (c) {
                      return {
                        name: c.name,
                        userInput: c.userInput
                      };
                    }),
                    cents: detailedMainCurrency.cents.map(function (c) {
                      return {
                        name: c.name,
                        userInput: c.userInput
                      };
                    })
                  });
                }

                detailedCurrencies.value.forEach(function (detailedCurrency) {
                  if (!detailedCurrency) {
                    console.log("NO DETAILED CURRENCY");
                  }

                  if (detailedCurrency.id === groupCurrency.value) {
                    //already added
                    return;
                  }

                  billsAndCoins.push({
                    currency: detailedCurrency.label,
                    bills: detailedCurrency.bills.map(function (b) {
                      return {
                        name: b.name,
                        userInput: b.userInput
                      };
                    }),
                    coins: detailedCurrency.coins.map(function (c) {
                      return {
                        name: c.name,
                        userInput: c.userInput
                      };
                    }),
                    cents: detailedCurrency.cents.map(function (c) {
                      return {
                        name: c.name,
                        userInput: c.userInput
                      };
                    })
                  });
                });
                cashFloat.billsAndCoinsByCurrency = {
                  opening: billsAndCoins
                }; // Print Closing receipt

                if (!hasLocation.value) {
                  _context2.next = 75;
                  break;
                }

                _context2.next = 73;
                return componentPrintClosingReceiptWithCashTransfers();

              case 73:
                _context2.next = 77;
                break;

              case 75:
                _context2.next = 77;
                return componentPrintClosingReceipt();

              case 77:
                _context2.next = 79;
                return closeCashfloat({
                  messages: cashNotes.value
                  /*form.message*/
                  ,
                  startAmounts: cashFloat.startAmounts,
                  amounts: expectedCashfloatsInCents
                  /*cashFloatAmount*/
                  ,
                  manualAmounts: finalManualCashfloatsInCents
                  /*form.cashFloatAmount*/
                  ,
                  totalCashSalesByCurrency: totalCashSalesByCurrency.value,
                  cashfloatUuid: cashFloat.uid,
                  closingSummaries: billsAndCoins,
                  userSwitch: cashFloat.userSwitch
                });

              case 79:
                _context2.next = 90;
                break;

              case 81:
                if (!hasLocation.value) {
                  _context2.next = 86;
                  break;
                }

                _context2.next = 84;
                return componentPrintClosingReceiptWithCashTransfers();

              case 84:
                _context2.next = 88;
                break;

              case 86:
                _context2.next = 88;
                return componentPrintClosingReceipt();

              case 88:
                _context2.next = 90;
                return closeCashfloat({
                  messages: cashNotes.value
                  /*form.message*/
                  ,
                  startAmounts: cashFloat.startAmounts,
                  amounts: expectedCashfloatsInCents
                  /*cashFloatAmount*/
                  ,
                  manualAmounts: finalManualCashfloatsInCents
                  /*form.cashFloatAmount*/
                  ,
                  totalCashSalesByCurrency: totalCashSalesByCurrency.value,
                  cashfloatUuid: cashFloat.uid,
                  userSwitch: cashFloat.userSwitch
                });

              case 90:
                // previous cashfloat amount logic concerns only Electron app with a device linked
                if (hasLocation.value) {
                  if (!isCashfloatCashedOut) {
                    // up to here user didn't cashed out the full closing amount
                    // we need to keep this info, it will be usefull for the next cashfloat opening
                    closingAmounts = {};
                    detailedCurrencies.value.forEach(function (detailedCurrency) {
                      closingAmounts[detailedCurrency.label] = (finalManualCashfloats.value[detailedCurrency.label] || 0) * 100;
                    });
                    cashfloatInfo = {
                      uuid: cashFloat.uid,
                      closingAmounts: closingAmounts,
                      isCashedOut: false
                    };
                    LogService.info("User didn't cash out cashfloat closing amount. Setting cashfloat info attached to previousCashfloat property in the state: ".concat(cashFloat.uid), {
                      params: {
                        previousCashfloat: cashfloatInfo
                      }
                    });
                    CashFloatModule.setPreviousCashFloat(cashfloatInfo);
                  } else {
                    LogService.info("User cashed out full cashfloat closing amount. Setting null to previousCashfloat property in the state: ".concat(cashFloat.uid));
                    CashFloatModule.setPreviousCashFloat(null);
                  }
                } else {
                  // user using a browser or an app in an unlinked device --> No logic for previous cashfloat amount will be considered
                  CashFloatModule.setPreviousCashFloat(null);
                }

                CashFloatModule.setCashFloat(null); // Ensure that no booking is remaining when sales are closed

                BookingModule.clearAllBookings(); // Now lets log current memory consumption

                try {
                  if (window.performance && window.performance.memory) {
                    memory = window.performance.memory;
                    mem = {
                      date: dayjs().utc().toISOString(),
                      totalJSHeapSize: memory.totalJSHeapSize / (1024 * 1024),
                      usedJSHeapSize: memory.usedJSHeapSize / (1024 * 1024),
                      jsHeapSizeLimit: memory.jsHeapSizeLimit / (1024 * 1024),
                      domMemory: (memory.totalJSHeapSize - memory.usedJSHeapSize) / (1024 * 1024)
                    };
                    LogService.info("Memory consumption after closing sales", {
                      params: {
                        memoryConsumption: mem
                      }
                    });
                  }
                } catch (err) {
                  // Couldn't log memory consumption
                  LogService.info("Error when trying to log memory consumption", {
                    params: {
                      error: err
                    }
                  }, LogLevel.Error);
                } // Dexie logs monitoring


                _context2.next = 96;
                return dexieDB.logs.count();

              case 96:
                unsynchedDexieLogsCount = _context2.sent;

                if (!unsynchedDexieLogsCount) {
                  _context2.next = 111;
                  break;
                }

                // log a message of how many logs were not synched
                retry = 3;

              case 99:
                if (!(retry > 0)) {
                  _context2.next = 111;
                  break;
                }

                _context2.prev = 100;
                _context2.next = 103;
                return LogService.infoDirect("Dexie Logs Monitoring: ".concat(unsynchedDexieLogsCount, " logs were not synched after closing sales"));

              case 103:
                return _context2.abrupt("break", 111);

              case 106:
                _context2.prev = 106;
                _context2.t4 = _context2["catch"](100);
                retry--;

              case 109:
                _context2.next = 99;
                break;

              case 111:
                _context2.next = 113;
                return resetGrowingCollecitonsFromUI();

              case 113:
                setDBReset(true);
                AppModule.updatedIsLoading(false);
                CashFloatModule.setIsClosingCashfloat(false); // take the user to the logout screen if he shall logout

                if (shallLogout.value) {
                  AuthModule.UserLogOut(); // remove gId parameter if it is set

                  if (AppModule.gid) {
                    AppModule.removeGID();
                  }

                  redirectToLoginPage();
                }

                hideDialog(); // monitor logs synching issues after sales are closed and cashfloat is cleared

                unsynchedLogsCount = LogsModule.logsPendingSynchronization.length;

                if (!unsynchedLogsCount) {
                  _context2.next = 134;
                  break;
                }

                // log a message of how many logs were not synched
                _retry = 3;

              case 121:
                if (!(_retry > 0)) {
                  _context2.next = 134;
                  break;
                }

                _context2.prev = 122;
                _context2.next = 125;
                return LogService.infoDirect("Logs Monitoring: ".concat(unsynchedLogsCount, " logs were not synched after closing sales, going to restore them"));

              case 125:
                AppModule.setIsRestoringLogs(true);
                return _context2.abrupt("break", 134);

              case 129:
                _context2.prev = 129;
                _context2.t5 = _context2["catch"](122);
                _retry--;

              case 132:
                _context2.next = 121;
                break;

              case 134:
                _context2.next = 140;
                break;

              case 136:
                _context2.prev = 136;
                _context2.t6 = _context2["catch"](60);
                // console.error(error);
                // if (cashFloat) {
                LogService.info("Error while closing cashfloat ".concat(cashFloat.uid), {
                  params: {
                    cashFloat: cashFloat,
                    error: _context2.t6
                  }
                }, LogLevel.Error); // }

                throw _context2.t6;

              case 140:
                _context2.next = 145;
                break;

              case 142:
                _context2.prev = 142;
                _context2.t7 = _context2["catch"](0);
                console.log(_context2.t7);

              case 145:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 142], [31, 37], [48, 55], [60, 136], [100, 106], [122, 129]]);
      }));
      return _componentCloseCashfloat.apply(this, arguments);
    }

    function componentPrintClosingReceipt() {
      return _componentPrintClosingReceipt.apply(this, arguments);
    }

    function _componentPrintClosingReceipt() {
      _componentPrintClosingReceipt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _CashFloatModule$cash2, _CashFloatModule$cash3, _CashFloatModule$cash4, _CashFloatModule$cash5, _CashFloatModule$cash6, _CashFloatModule$cash8, _CashFloatModule$cash9;

        var groupInfo, d, impressionDate, seller, firstName, lastName, sellerName, createdAt, openingDate, closedAt, closingDate, messages, uid, totalCashFloats, initialCashFloatAmounts, initialCashFloatAmountsStr, totalCashSalesStr, changeGivenBackStr, finalAmounts, finalAmountsStr, cashDiffs, cashDiffsStr, _i6, _CashFloatModule$cash7, _finalAmounts$currenc, currencyInfo, currency, receiptInfo, amountsPerVat;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getGroupInfo();

              case 2:
                groupInfo = _context3.sent;
                d = dayjs(new Date());
                impressionDate = formatDateTime(d.toString());
                seller = UserModule.user;
                firstName = seller.firstName, lastName = seller.lastName;
                sellerName = "".concat(firstName && firstName[0].toUpperCase() || "", " ").concat(lastName && lastName[0].toUpperCase() || "");
                createdAt = dayjs((_CashFloatModule$cash2 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash2 === void 0 ? void 0 : _CashFloatModule$cash2.createdAt);
                openingDate = formatDateTime(createdAt.toString());
                closedAt = (_CashFloatModule$cash3 = CashFloatModule.cashFloat) !== null && _CashFloatModule$cash3 !== void 0 && _CashFloatModule$cash3.closeDate ? dayjs((_CashFloatModule$cash4 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash4 === void 0 ? void 0 : _CashFloatModule$cash4.closeDate) : dayjs((_CashFloatModule$cash5 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash5 === void 0 ? void 0 : _CashFloatModule$cash5.updatedAt);
                closingDate = formatDateTime(closedAt.toString());
                messages = cashNotes.value;
                uid = (_CashFloatModule$cash6 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash6 === void 0 ? void 0 : _CashFloatModule$cash6.uid;
                totalCashFloats = {};
                initialCashFloatAmounts = {};
                initialCashFloatAmountsStr = {};
                totalCashSalesStr = {};
                changeGivenBackStr = {};
                finalAmounts = {};
                finalAmountsStr = {};
                cashDiffs = {};
                cashDiffsStr = {};

                for (_i6 in currencies.value) {
                  currencyInfo = currencies.value[_i6];
                  currency = currencies.value[_i6].label; //totalCashFloats[currency] = await getCashBookingsAmount(currencyInfo);

                  totalCashFloats[currency] = expectedCashfloats.value[currency];
                  initialCashFloatAmounts[currency] = (((_CashFloatModule$cash7 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash7 === void 0 ? void 0 : _CashFloatModule$cash7.startAmounts[currency]) || 0) / 100;
                  initialCashFloatAmountsStr[currency] = initialCashFloatAmounts[currency].toFixed(2);
                  totalCashSalesStr[currency] = (totalCashSalesByCurrency.value[currency] || 0).toFixed(2);

                  if (currency === groupCurrency.value) {
                    changeGivenBackStr[currency] = getSumOfCashOut.value.toFixed(2);
                  } // we take the validAmount in the most recent user switch


                  finalAmounts[currency] = finalManualCashfloats.value[currency];
                  finalAmountsStr[currency] = (_finalAmounts$currenc = finalAmounts[currency]) === null || _finalAmounts$currenc === void 0 ? void 0 : _finalAmounts$currenc.toFixed(2);
                  cashDiffs[currency] = (finalAmounts[currency] || 0) - (totalCashFloats[currency] || 0);
                  cashDiffsStr[currency] = cashDiffs[currency].toFixed(2);
                } // get the group currency


                receiptInfo = {
                  subTitle: t("receipt.cash-information"),
                  groupInfo: groupInfo,
                  currencies: currencies.value,
                  businessIdField: t("field.vat"),
                  impressionDate: {
                    key: t("receipt.impression-date"),
                    value: impressionDate
                  },
                  openingDate: {
                    key: t("receipt.opening-date"),
                    value: openingDate
                  },
                  closingDate: {
                    key: t("receipt.closing-date"),
                    value: closingDate
                  },
                  seller: {
                    key: t("receipt.seller"),
                    value: sellerName
                  },
                  cf: {
                    key: t("receipt.cash-float-id"),
                    value: uid
                  },
                  messages: {
                    key: t("receipt.message"),
                    values: messages
                  },
                  initialCashFloats: {
                    key: t("receipt.initial-cash-float"),
                    values: initialCashFloatAmountsStr
                  },
                  totalCashSalesByCurrency: {
                    key: t("receipt.total-cash-sales"),
                    values: totalCashSalesStr
                  },
                  changeGivenBack: {
                    key: t("multicurrencies.change"),
                    values: changeGivenBackStr
                  },
                  //
                  finalCashFloats: {
                    key: t("receipt-final-cash-float"),
                    values: finalAmountsStr
                  },
                  //
                  cashDifferences: {
                    key: t("receipt.cash-difference"),
                    values: cashDiffsStr
                  },
                  fiancialChannels: t("receipt.financial-channels"),
                  fieldNet: t("receipt.net"),
                  fieldGross: t("receipt.gross"),
                  fieldVatAmount: t("receipt.vat-amount")
                }; // close cashpoint to get the Fiskaly closing statement

                _context3.next = 27;
                return closeCashPoint();

              case 27:
                amountsPerVat = _context3.sent;

                if (amountsPerVat) {
                  receiptInfo.amountsPerVat = amountsPerVat;
                }

                LogService.info("Cashfloat ".concat((_CashFloatModule$cash8 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash8 === void 0 ? void 0 : _CashFloatModule$cash8.uid, " receipt, cash differences"), {
                  smtzuid: (_CashFloatModule$cash9 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash9 === void 0 ? void 0 : _CashFloatModule$cash9.uid,
                  receiptInfo: receiptInfo,
                  cashDifferences: receiptInfo.cashDifferences
                });
                console.log("closingReceiptInfo");
                console.log(receiptInfo);
                printClosingReceipt(receiptInfo);

              case 33:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _componentPrintClosingReceipt.apply(this, arguments);
    }

    function showCashNoteDialog(currency) {
      cashNoteDialogVisibility.value = true;
      cashNoteCurrency.value = currency;
    }
    /**
     * Collects data for closing receipt and print it with all cash transfers
     * Triggered when user logs out
     */
    // TODO HAMZA: thisis fully done, you just need to edit the receipt template to consider the case where we have linked device


    function componentPrintClosingReceiptWithCashTransfers() {
      return _componentPrintClosingReceiptWithCashTransfers.apply(this, arguments);
    }

    function _componentPrintClosingReceiptWithCashTransfers() {
      _componentPrintClosingReceiptWithCashTransfers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _CashFloatModule$cash10, _CashFloatModule$cash11, _CashFloatModule$cash12, _CashFloatModule$cash13, _CashFloatModule$cash14, _CashFloatModule$cash15, _CashFloatModule$cash16, _CashFloatModule$cash17;

        var groupInfo, d, impressionDate, seller, firstName, lastName, sellerName, createdAt, openingDate, closedAt, closingDate, uid, firstCurrency, messages, initialCashFloat, initialCashFloatStr, totalCashFloat, totalCashSalesStr, finalAmount, finalAmountStr, cashDiff, cashDiffStr, hasCashTransfersLogic, ttlCashIn, ttlCashOut, expectedCashfloat, addedCashfloat, difference, receiptInitialCashFloats, receiptInfo, amountsPerVat;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getGroupInfo();

              case 2:
                groupInfo = _context4.sent;
                d = dayjs(new Date());
                impressionDate = formatDateTime(d.toString());
                seller = UserModule.user;
                firstName = seller.firstName, lastName = seller.lastName;
                sellerName = "".concat(firstName && firstName[0].toUpperCase() || "", " ").concat(lastName && lastName[0].toUpperCase() || "");
                createdAt = dayjs((_CashFloatModule$cash10 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash10 === void 0 ? void 0 : _CashFloatModule$cash10.createdAt);
                openingDate = formatDateTime(createdAt.toString());
                closedAt = (_CashFloatModule$cash11 = CashFloatModule.cashFloat) !== null && _CashFloatModule$cash11 !== void 0 && _CashFloatModule$cash11.closeDate ? dayjs((_CashFloatModule$cash12 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash12 === void 0 ? void 0 : _CashFloatModule$cash12.closeDate) : dayjs((_CashFloatModule$cash13 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash13 === void 0 ? void 0 : _CashFloatModule$cash13.updatedAt);
                closingDate = formatDateTime(closedAt.toString());
                uid = (_CashFloatModule$cash14 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash14 === void 0 ? void 0 : _CashFloatModule$cash14.uid; // get the group currency

                firstCurrency = currencies.value.find(function (c) {
                  return c.label === groupCurrency.value;
                });

                if (firstCurrency) {
                  _context4.next = 16;
                  break;
                }

                return _context4.abrupt("return");

              case 16:
                messages = cashNotes.value;
                initialCashFloat = (((_CashFloatModule$cash15 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash15 === void 0 ? void 0 : _CashFloatModule$cash15.startAmounts[firstCurrency.label]) || 0) / 100;
                initialCashFloatStr = initialCashFloat.toFixed(2);
                _context4.next = 21;
                return getCashBookingsAmount(firstCurrency);

              case 21:
                totalCashFloat = _context4.sent;
                totalCashSalesStr = (totalCashSalesByCurrency.value[firstCurrency.label] || 0).toFixed(2); // we take the validAmount in the most recent user switch

                finalAmount = finalManualCashfloats.value[firstCurrency.label] || 0; //form.cashFloatAmount;

                finalAmountStr = Number(finalAmount).toFixed(2);
                cashDiff = finalAmount - totalCashFloat / 100;
                cashDiffStr = cashDiff.toFixed(2); ///// Cash transfers logic fields

                hasCashTransfersLogic = true;
                ttlCashIn = getSumOfCashIn.value + (totalCashSalesByCurrency.value[firstCurrency.label] || 0);
                ttlCashOut = getSumOfCashOut.value;
                expectedCashfloat = expectedCashfloats.value[firstCurrency.label] || 0;
                addedCashfloat = finalManualCashfloats.value[firstCurrency.label] || 0;
                difference = addedCashfloat - expectedCashfloat; /////

                receiptInitialCashFloats = {};
                receiptInitialCashFloats[firstCurrency.label] = (cashFloatStartAmounts.value[firstCurrency.label] || 0).toFixed(2);
                receiptInfo = {
                  subTitle: t("receipt.cash-information"),
                  groupInfo: groupInfo,
                  currencies: [firstCurrency],
                  businessIdField: t("field.vat"),
                  impressionDate: {
                    key: t("receipt.impression-date"),
                    value: impressionDate
                  },
                  openingDate: {
                    key: t("receipt.opening-date"),
                    value: openingDate
                  },
                  closingDate: {
                    key: t("receipt.closing-date"),
                    value: closingDate
                  },
                  seller: {
                    key: t("receipt.seller"),
                    value: sellerName
                  },
                  cf: {
                    key: t("receipt.cash-float-id"),
                    value: uid
                  },
                  messages: {
                    key: t("receipt.message"),
                    values: messages
                  },
                  // initialCashFloat: {
                  //   key: t("receipt.initial-cash-float"),
                  //   value: initialCashFloatStr,
                  // },
                  // totalCashSales: {
                  //   key: t("receipt.total-cash-sales"),
                  //   value: totalCashSalesStr,
                  // },
                  // finalCashFloat: {
                  //   key: t("receipt-final-cash-float"),
                  //   value: finalAmountStr,
                  // },
                  // cashDifference: {
                  //   key: t("receipt.cash-difference"),
                  //   value: cashDiffStr,
                  // },
                  hasCashTransfersLogic: true,
                  initialCashFloats: {
                    key: t("receipt.initial-cash-float"),
                    values: receiptInitialCashFloats
                  },
                  ttlCashIn: {
                    key: t("cashfloat.cash-income-and-entries"),
                    value: (ttlCashIn || 0).toFixed(2)
                  },
                  ttlCashOut: {
                    key: t("cashfloat.outflow-and-withdrawal"),
                    value: ttlCashOut.toFixed(2)
                  },
                  expectedCashfloat: {
                    key: t("cashfloat.expected-amount"),
                    value: expectedCashfloat.toFixed(2)
                  },
                  addedCashfloat: {
                    key: t("cashfloat.counted-amount"),
                    value: addedCashfloat.toFixed(2)
                  },
                  difference: {
                    key: t("cashfloat.difference"),
                    value: difference.toFixed(2)
                  },
                  fiancialChannels: t("receipt.financial-channels"),
                  fieldNet: t("receipt.net"),
                  fieldGross: t("receipt.gross"),
                  fieldVatAmount: t("receipt.vat-amount")
                }; // close cashpoint to get the Fiskaly closing statement

                _context4.next = 38;
                return closeCashPoint();

              case 38:
                amountsPerVat = _context4.sent;

                if (amountsPerVat) {
                  receiptInfo.amountsPerVat = amountsPerVat;
                }

                LogService.info("Cashfloat ".concat((_CashFloatModule$cash16 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash16 === void 0 ? void 0 : _CashFloatModule$cash16.uid, " receipt, cash differences"), {
                  smtzuid: (_CashFloatModule$cash17 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash17 === void 0 ? void 0 : _CashFloatModule$cash17.uid,
                  receiptInfo: receiptInfo,
                  cashDifferences: receiptInfo.cashDifferences
                });
                console.log("closingReceiptInfo");
                console.log(receiptInfo);
                printClosingReceipt(receiptInfo);

              case 44:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _componentPrintClosingReceiptWithCashTransfers.apply(this, arguments);
    }

    function confirmDetailedCashfloat() {
      // We confirm here what the user entered as details of coins and bills
      // property already binded, so lets do nothing
      var currency = coinsAndBillsDialogCurrency.value;
      var detailedCurrency = detailedCurrencies.value.find(function (c) {
        return c.label === currency;
      });

      if (!currency || !detailedCurrency) {
        return;
      }

      LogService.info("User confirmed detailed cashfloat when closing sales", {
        currency: currency,
        detailedCurrency: detailedCurrency
      });
      var cashClosingSum = sumCashByCurrency(currency);

      if (cashClosingSum) {
        finalManualCashfloats.value[currency] = cashClosingSum;
      }

      showCoinsAndBillsDialog.value = false;
    }

    function cancelDetailedCashfloat() {
      // Here we cancel what the user has entered
      // we initiate the object
      var currency = coinsAndBillsDialogCurrency.value;
      LogService.info("User canceled detailed cashfloat when closing sales", {
        currency: currency
      });
      detailedCurrencies.value = initialDetailedCurrencies;
      showCoinsAndBillsDialog.value = false;
    }

    function handleInputFocus(event) {
      if (event.target.value === "0") {
        event.target.value = "";
      }
    }

    function handleInputBlur(event) {
      if (event.target.value === "") {
        event.target.value = "0";
      }
    }

    return {
      t: t,
      CashfloatType: CashfloatType,
      currencies: currencies,
      detailedCurrencies: detailedCurrencies,
      totalByCurrency: totalByCurrency,
      cashfloatOpeningAmount: cashfloatOpeningAmount,
      sumCashByCurrency: sumCashByCurrency,
      scrollToTop: scrollToTop,
      cashDetailsArea: cashDetailsArea,
      scrollTo: scrollTo,
      expectedCashfloats: expectedCashfloats,
      finalManualCashfloats: finalManualCashfloats,
      differenceValues: differenceValues,
      cashFloatStartAmounts: cashFloatStartAmounts,
      isLoading: isLoading,
      groupCurrency: groupCurrency,
      groupCurrencySymbol: groupCurrencySymbol,
      iconStyle: iconStyle,
      iconContent: iconContent,
      iconAlt: iconAlt,
      drawerIconStyle: drawerIconStyle,
      drawerIconContent: drawerIconContent,
      drawerIconAlt: drawerIconAlt,
      userFirstName: userFirstName,
      EditIcon: EditIcon,
      displayCoinsAndBillsDialog: displayCoinsAndBillsDialog,
      showCoinsAndBillsDialog: showCoinsAndBillsDialog,
      locationsList: locationsList,
      locationId: locationId,
      initialDetailedCurrencies: initialDetailedCurrencies,
      totalCashSalesWithoutRefund: totalCashSalesWithoutRefund,
      totalCashRefund: totalCashRefund,
      hasLocation: hasLocation,
      ModalStatus: ModalStatus,
      getSumOfCashOut: getSumOfCashOut,
      getSumOfCashIn: getSumOfCashIn,
      willMoneyStayInDrawer: willMoneyStayInDrawer,
      resetLocationId: resetLocationId,
      showErrorMsg: showErrorMsg,
      cashNoteDialogVisibility: cashNoteDialogVisibility,
      cashNotes: cashNotes,
      currencySymbol: currencySymbol,
      componentCloseCashfloat: componentCloseCashfloat,
      componentPrintClosingReceipt: componentPrintClosingReceipt,
      totalChangeGivenBack: totalChangeGivenBack,
      showCashNoteDialog: showCashNoteDialog,
      cashNoteCurrency: cashNoteCurrency,
      totalCashSalesByCurrency: totalCashSalesByCurrency,
      confirmDetailedCashfloat: confirmDetailedCashfloat,
      cancelDetailedCashfloat: cancelDetailedCashfloat,
      getSelectedDetailedCurrency: getSelectedDetailedCurrency,
      handleInputFocus: handleInputFocus,
      handleInputBlur: handleInputBlur
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var i, currency, startAmount, totalCashSales;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              AppModule.updatedIsLoading(true);
              _context5.next = 3;
              return getCashBookingsAmountWithoutRefund();

            case 3:
              _this.totalCashSalesWithoutRefund = _context5.sent;
              _context5.next = 6;
              return getCashRefund();

            case 6:
              _context5.t0 = _context5.sent;
              _this.totalCashRefund = _context5.t0 / 100;
              _context5.next = 10;
              return getCashChange();

            case 10:
              _context5.t1 = _context5.sent;
              _this.totalChangeGivenBack = _context5.t1 / 100;

              for (i in _this.currencies) {
                currency = _this.currencies[i].label;
                startAmount = _this.cashFloatStartAmounts[currency] || 0;
                totalCashSales = _this.totalCashSalesByCurrency[currency] || 0;

                if (currency === _this.groupCurrency) {
                  _this.expectedCashfloats[currency] = startAmount + (totalCashSales + _this.getSumOfCashIn - _this.getSumOfCashOut);
                  _this.finalManualCashfloats[currency] = _this.expectedCashfloats[currency];
                } else {
                  _this.expectedCashfloats[currency] = startAmount + totalCashSales;
                  _this.finalManualCashfloats[currency] = _this.expectedCashfloats[currency];
                }
              }

              AppModule.updatedIsLoading(false);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  unmounted: function unmounted() {
    clearShallLogout();
  },
  methods: {
    cancel: function cancel() {
      CashFloatModule.setIsClosingCashfloat(false);
    },
    openDrawer: function openDrawer() {
      var _window$electronAPI;

      (_window$electronAPI = window.electronAPI) === null || _window$electronAPI === void 0 ? void 0 : _window$electronAPI.printCommonReceipt("");
    },
    toggleModalVisible: function toggleModalVisible(item) {
      ModalModule.setStatus(item);
    },
    shakeText: debounce(function (currency) {
      var textElement = this.$refs["add-note-".concat(currency)][0];

      if (!textElement) {
        return;
      }

      textElement.classList.add("shake-animation");
      textElement.classList.add("red-text"); // Remove the shake class after the animation ends

      setTimeout(function () {
        textElement.classList.remove("shake-animation");
        textElement.classList.remove("red-text");
      }, 500);
    }, 500)
  }
});